// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"Reports_pageTitle__3vJpJ","mainTableContainer":"Reports_mainTableContainer___fkCm","countryBox":"Reports_countryBox__3ZsAr"};